import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useStore } from '@/models';
import { useSettingList, usePartnerList } from '@/hooks/footer';

import MbFooter from './mbFooter';
import PcFooter from './pcFooter';
interface Props {
  padding?: string | number;
}

const Footer: React.FC<Props> = ({ padding }) => {
  const { t } = useTranslation();

  const { push } = useHistory();

  return (
    <>
      <PcFooter />
      <MbFooter padding={padding} />
    </>
  );
};

export default observer(Footer);
